import { useState } from "react";

import { useEscape } from "../../hooks/useEscape";

import Close from "../../assets/close.svg";
import { messageAndErrorStore, userStore } from "../../store/Store";

export default function DeleteAdjustment({
  setTrigger,
  id,
  setAdjustments,
  name,
}) {
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  const [pending, setPending] = useState(false);

  useEscape(setTrigger);

  const handleClose = () => {
    setTrigger(false);
  };

  const handleClick = (valueStr) => {
    if (valueStr === "No") {
      setTrigger(false);
      return;
    } else {
      setPending(true);

      var reqBody = {
        table: "invoice_adjustments_tbl",
        id,
        updated_by_id: currentUser.id,
        project_id: 0,
      };
      const controller = new AbortController();

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + JwtToken);

      const requestOptions = {
        method: "DELETE",
        headers,
        body: JSON.stringify(reqBody),
        signal: controller.signal,
      };

      fetch(`${process.env.REACT_APP_BACKEND}/pc/delete-record`, requestOptions)
        .then((res) => {
          if (!res.ok) {
            toggleNewMessage("Something Went Wrong status: ", res.status);
            return;
          } else {
            setAdjustments();
            setPending(false);
            setTrigger(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setPending(false);
          toggleNewMessage("Something Went Wrong");
          return;
        })
        .finally(() => setPending(false));
      return () => controller.abort();
    }
  };
  return (
    <div className="popup">
      <div className="popup-inner-add-company">
        {!pending && <img src={Close} onClick={handleClose} alt="close" />}
        <p>{`Are you sure you want to delete the adjustment for ${name}?`}</p>
        {!pending && (
          <button className="delete-btn" onClick={() => handleClick("Yes")}>
            Yes
          </button>
        )}
        {!pending && (
          <button className="propx-btn" onClick={() => handleClick("No")}>
            No
          </button>
        )}
        {pending && (
          <button
            className="btn btn-secondary"
            style={{ margin: "20px 20px 20px 0" }}
            disabled
          >
            Submitting...
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        )}
      </div>
    </div>
  );
}
